import Image from "next/image";
import { getDebateThumbnail } from "../Discuss/util";
import React from "react";

const ReportThumb = React.memo(
  ({
    data,
    width,
    height,
    className,
    priority = false,
    loading,
    ...props
  }: {
    data: any;
    width?: number;
    height?: number;
    className?: string;
    priority?: boolean;
    loading?: "lazy" | "eager";
  } & React.ImgHTMLAttributes<HTMLImageElement>) => {
    return (
      <Image
        src={getDebateThumbnail(data?.thumbnail_url, data?.id) || ""}
        alt="debate-thumbnail"
        width={width || 800}
        height={height || 600}
        className={` object-cover aspect-[3/2] h-auto bg-gray20 discuss-top-thumb ${className}`}
        id="discuss-top-thumb"
        sizes="(max-width: 768px) 100vw, 800px"
        priority={priority}
        loading={loading}
        {...props}
      />
    );
  }
);
ReportThumb.displayName = "ReportThumb";

export default ReportThumb;
